import { createMemoryRouter, Outlet, RouterProvider } from "react-router-dom";
import Login from "./Login";
import Mfa from "./Mfa";
import MfaSetup from "./MfaSetup";
import { createTheme, ThemeProvider } from "@mui/material";
import UpdatePassword from "./UpdatePassword";
import IFrame from "./IFrame";

const router = createMemoryRouter([
  {
    path: "/",
    Component: Layout,
    children: [
      {
        path: "/",
        Component: Login,
      },
      {
        path: "mfa",
        Component: Mfa,
      },
      {
        path: "mfasetup",
        Component: MfaSetup,
      },
      {
        path: "updatepassword",
        Component: UpdatePassword,
      },
      {
        path: "iframe",
        Component: IFrame,
      },
    ],
  },
]);

const theme = createTheme({
  palette: {
    primary: {
      main: '#00acac',
    },
  },
});

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <RouterProvider router={router} />
    </ThemeProvider>
  );
}

export function Layout() {
  return <Outlet/>
}